export type TMapTab = 'default' | 'panorama' | 'similarOffers';
export const MapTab = {
  default: 'default' as 'default',
  panorama: 'panorama' as 'panorama',
  similarOffers: 'similarOffers' as 'similarOffers',
};

export interface IMapTabs {
  activeTab: TMapTab;
}

export interface IMapTabChanged {
  newActiveTab: TMapTab;
  type: 'IMapTabChanged';
}

export function changeTab(newActiveTab: TMapTab): IMapTabChanged {
  return {
    newActiveTab,
    type: 'IMapTabChanged',
  };
}

const defaultState = {
  activeTab: MapTab.default,
};

export function mapTabsReducer(state: IMapTabs, action: IMapTabChanged): IMapTabs {
  switch (action.type) {
    case 'IMapTabChanged':
      return { ...state, activeTab: action.newActiveTab };

    default:
      return state || defaultState;
  }
}
